import React, { useEffect, useState } from "react";
import { Form, Offcanvas, Button } from "react-bootstrap";
import { storeCustomerServices } from "../../../../../APIServices/SitePilotManagement/StoreManagement/storeCustomerServices";

const AddCustomer = ({ show, hide, title, getStoreCustomerList }) => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [loader, setLoader] = useState(false);

  const addNewStoreCustomer = async () => {
    setLoader(true)
    let userData = {}
    userData.name = name
    userData.email = email
    userData.phone = phone
    let data = await storeCustomerServices.addNewStoreCustomer(userData)
    if (data?.statusCode === 200) {
      getStoreCustomerList()
      clearData();
    }
    setLoader(false)
  }
  
  const clearData = () => {
    setName("");
    setEmail("");
    setPhone("");
    setLoader(false)
    hide();
  }

  useEffect(() => {
    if (!show) {
      setName("");
      setEmail("");
      setPhone("");
      setLoader(false)
    }
  }, [show]);

  return (
    <Offcanvas show={show} onHide={hide} placement="end">
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>{title}</Offcanvas.Title>
      </Offcanvas.Header>

      <Offcanvas.Body>
        <Form>
          <Form.Group className="mb-2">
            <Form.Label>
              Name <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              name="userName"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Enter Name"
            />
          </Form.Group>
          <Form.Group className="mb-2">
            <Form.Label>
              Email <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              name="userName"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter Email"
            />
          </Form.Group>
          <Form.Group className="mb-2">
            <Form.Label>
              Phone <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              type="tel"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              placeholder="Enter Phone"
            />
          </Form.Group>
          <div className="d-flex justify-content-end gap-2 mt-3">
            <Button onClick={clearData} style={{ fontSize: 12 }} variant="light" >
              Cancel
            </Button>
            <Button
              disabled={!name || !phone || !email || loader}
              onClick={addNewStoreCustomer}
              style={{ fontSize: 12 }}>
                {title}
            </Button>
          </div>
        </Form>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default AddCustomer;
